export const StorageKeys = {
  AUTH_TOKENS: 'auth_tokens',
  SETTINGS: 'settings',
  USER: 'user',
} as const
